module.exports = __webpack_public_path__ + "img/small-2.ff27a928.webp";